"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootStyles = void 0;
/**
 * NOTE: A `fixed` position prevents some of the scrolling bugs that an
 * `absolute` position causes in Webkit browsers.
 * @see [Hiding Content for Accessibility](https://snook.ca/archives/html_and_css/hiding-content-for-accessibility)
 * @see [Hide content](https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/)
 * */
exports.rootStyles = {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    wordWrap: 'normal',
};
//# sourceMappingURL=root.js.map